import React, { useState } from "react";
import qrimg from "../../Images/Rectangle.png";
import QRprofileShare from "./QRprofileShare";

const QRshareModal = ({ closeModal }) => {

    const [modal, setModal] = useState(false);

    const handleClick = () => {
        setModal(!modal);
    };

    return (
        <>
            <section className="QRsharemodalSec">
                <div className="qrshareInn">
                    <div className="ModClosebtn" onClick={() => closeModal()}>
                        <i className="fa-solid fa-xmark"></i>
                    </div>
                    <figure className="modQRimg">
                        <img src={qrimg} alt="QR" />
                    </figure>
                    <button className="qrDwnld">
                        Download
                    </button>
                    <button className="modshareBtn" onClick={handleClick}>
                        Share <i className="fa-regular fa-share-from-square"></i>
                    </button>
                </div>
            </section>
            {modal && <QRprofileShare closeProfile={setModal} />}
        </>
    )
}

export default QRshareModal